import { useLocale as useNextIntlLocale } from "next-intl"

import type { AppUserDataLoader } from "@/data/dataLoader"
import { UserPreferredLanguage } from "@/lib/zenstack/.logical-prisma-client"

// Preferred language should be set in the middleware. We're using this hook to get the locale
// from the pathname, but it's not always reliable.
export function useLocale({ appUser }: { appUser?: AppUserDataLoader | null } = {}): UserPreferredLanguage {
  const nextIntlLocale = useNextIntlLocale()
  const locale = appUser?.preferredLanguage ?? nextIntlLocale

  return locale as UserPreferredLanguage
}
